/*
  Gentle cart suggestions from Shopify's product recommendations.
  Fills every empty .byla-cart-upsell slot in the cart drawer (also after the
  drawer re-renders), and adds a suggested product with one tap.

  Suggestions are based on the products she added first (oldest cart items),
  so after a one-tap add the answer is already cached and the rows don't jump.
  The add request asks for the drawer sections in the same response, so the
  cart updates without a second round trip.
*/
(function () {
  var cache = {};

  function fetchRows(url, productId, intent) {
    var key = productId + ':' + intent;
    if (!cache[key]) {
      cache[key] = fetch(url + '?section_id=byla-cart-upsell&limit=10&intent=' + intent + '&product_id=' + productId)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('.byla-cart-upsell__row'));
        })
        .catch(function () {
          delete cache[key];
          return [];
        });
    }
    return cache[key];
  }

  function fill(slot) {
    if (slot.dataset.state) return;
    slot.dataset.state = 'loading';

    var url = slot.dataset.url;
    var limit = parseInt(slot.dataset.limit, 10) || 2;
    var inCart = (slot.dataset.cartIds || '').split(',').filter(Boolean);
    var sources = inCart.slice().reverse().slice(0, 3);
    var intents = slot.dataset.intent === 'related' ? ['related'] : ['complementary', 'related'];
    var requests = [];
    intents.forEach(function (intent) {
      sources.forEach(function (productId) {
        requests.push({ productId: productId, intent: intent });
      });
    });

    var picked = [];
    var seen = {};

    function next(index) {
      if (picked.length >= limit || index >= requests.length) return Promise.resolve();
      var request = requests[index];
      return fetchRows(url, request.productId, request.intent).then(function (rows) {
        rows.forEach(function (row) {
          var id = row.dataset.productId;
          if (picked.length < limit && inCart.indexOf(id) === -1 && !seen[id]) {
            seen[id] = true;
            picked.push(row.cloneNode(true));
          }
        });
        return next(index + 1);
      });
    }

    next(0).then(function () {
      slot.dataset.state = 'done';
      if (!picked.length || !slot.isConnected) return;
      var list = document.createElement('ul');
      list.className = 'byla-cart-upsell__list';
      list.setAttribute('role', 'list');
      picked.forEach(function (row) {
        list.appendChild(row);
      });
      slot.appendChild(list);
      slot.classList.add('byla-cart-upsell--ready');
    });
  }

  function scan() {
    document.querySelectorAll('.byla-cart-upsell:not([data-state])').forEach(fill);
  }

  function add(button) {
    var drawer = document.querySelector('cart-drawer');
    var sections =
      drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (section) {
            return section.id;
          })
        : [];

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: data.sections }, false);
        } else {
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
        }
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.byla-cart-upsell__add[data-variant-id]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    add(button);
  });

  function start() {
    var root = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(scan).observe(root, { childList: true, subtree: true });
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
